export const BaseEndpoint = '/api';
export const ContactQueriesEndpoint = '/contact';
